import { cloneDeep, differenceWith, isEqual } from 'lodash';

export const defaultClaimSrcProperties = {
    claimNumbers: '',
    pins: '',
    modelCdList:'',
    pipNumbers: '',
    baseCodeIds: '',
    productSubSeriesIds: '',
    branchIds: '',
    partNumber: '',
    includeReplacementParts: false,
    serialNumber: {
        from: 0,
        to: 0,
    },
    buildDate: {
        from: 0,
        to: 0,
    },
    buildMonth: {
        from: 0,
        to: 0,
    },
    processDate: {
        from: 0,
        to: 0,
    },
    creditDate: {
        from: 0,
        to: 0,
    },
    factoryCode: '',
    factoryClaimTypeIds: '',
    regionCode: '',
    dealerAccount: '',
    functionCodeName: '',
    designTeamCode: '',
    manufacturingModule: '',
    manufacturingFactoryCode: '',
    componentFunctionCodeName: '',
    componentFactoryCode: '',
    componentPin: '',
    supplierId: '',
    noSupplierAssigned: false,
    option: {
        includeComplaintCauseCorrection: false,
        includeComplaintCauseCorrectionTranslation: false,
        includeRejects: false,
        include17CharacterPin: false,
        includeAttachmentCount: false,
        includeExpandedClaimDetail: false,
        includeAGCMDView: false
    },
    productSeriesIds: '',
    partDescription: '',
    creditMemoNumber:'' ,
    workOrderNumber:'',
    branchType:'US Dollar',
    nonDeereclaimNumbers:''

};

export const defaultWorklistProperties = {
    auditCode: '-1',
    baseCodeIds: '',
    branchIds: '',
    buildDate: {
        from: 0,
        to: 0,
    },
    claimNumbers: '',
    factoryClaimTypeId: '',
    factoryCode: '',
    partNumber: '',
    pins: '',
    processDate: {
        from: 0,
        to: 0,
    },
    creditDate: {
        from: 0,
        to: 0,
    },
    productSeriesIds: '',
    productSubSeriesIds: '',

};

export function convertToArray ( value ) {

    const convertedValue = [];
    if ( value !== null && typeof value === 'object' ) {

        value.forEach( attr => {

            convertedValue.push( ( attr.value ).toString() );

        } );

    } else if ( value ) convertedValue.push( value );
    return convertedValue;

}

export function convertToArrayProdSeries ( value ) {

    const convertedValue = [];
    if ( value !== null && typeof value === 'object' ) {

        value.forEach( attr => {

            convertedValue.push( ( attr.productSeriesId ).toString() );

        } );

    } else if ( value ) convertedValue.push( value );
    return convertedValue;

}

export function getUserEditedInputs ( updatedProperties, callFrom = 'Claim' ) {

    let defaultProperties = cloneDeep( defaultWorklistProperties );
    if ( callFrom === 'Claim' ) defaultProperties = cloneDeep( defaultClaimSrcProperties );

    const modifiedProperties = cloneDeep( updatedProperties );
    modifiedProperties.option = {};
    defaultProperties.option = {};
    let modifiedInput = [];
    if ( !isEqual( modifiedProperties, defaultProperties ) ) {

        modifiedInput = differenceWith(
            Object.entries( modifiedProperties ),
            Object.entries( defaultProperties ), isEqual,
        );

    }
    return modifiedInput;

}

export function getUserEditedInputsNonDeereClaims ( updatedProperties, callFrom = 'NonDeereClaim' ) {

    let defaultProperties = cloneDeep( defaultWorklistProperties );
    if ( callFrom === 'NonDeereClaim') defaultProperties = cloneDeep( defaultClaimSrcProperties );

    const modifiedProperties = cloneDeep( updatedProperties );
    modifiedProperties.option = {};
    defaultProperties.option = {};
    let modifiedInput = [];
    if ( !isEqual( modifiedProperties, defaultProperties ) ) {

        modifiedInput = differenceWith(
            Object.entries( modifiedProperties ),
            Object.entries( defaultProperties ), isEqual,
        );

    }
    return modifiedInput;

}
export function getOnlyValues ( items ) {

    const series = [];

    if ( !items ) return '';

    items.forEach( item => {

        series.push( item.label );

    } );

    return series.join( ' , ' );

}

export function getDateFormat ( givenDate, propertyName ) {

    if ( givenDate !== '' ) {

        const userDate = new Date( givenDate ),
            year = userDate.getUTCFullYear(),
            day = userDate.getUTCDate() < 10 ? `0${userDate.getUTCDate()}` : userDate.getUTCDate(),
            month = ( userDate.getUTCMonth() + 1 ) < 10 ? `0${userDate.getUTCMonth() + 1}` : ( userDate.getUTCMonth() + 1 );

        if ( propertyName === 'buildMonth' ) return [year, month].join( '' );
        return [month, day, year].join( '/' );

    }
    return '';

}
